import { ROUTES } from "@/router";

/** Top-level path segments that are not tenant names */
const NON_TENANT_SEGMENTS = [
  ROUTES.LEGAL,
  ROUTES.AUTH,
  "admin",
  ROUTES.SIGN_OUT,
  ROUTES.REGISTER,
  ROUTES.SELECT_TENANT,
];

/**
 * Extracts tenant name from the current URL pathname.
 * Returns empty string if the first segment is a known non-tenant route.
 */
export const getTenantFromUrl = (): string => {
  const segment = window.location.pathname.split("/")[1] ?? "";
  if (!segment || NON_TENANT_SEGMENTS.includes(segment)) {
    return "";
  }
  return segment;
};
